import * as navigation from "./navigation";
import socialLinks from "./socialLinks";

export { navigation, socialLinks };
